import type { TableColumnsType } from 'ant-design-vue'

// 字节渠道列表
export const FILTER_CHANNEL_LIST = ['douyinOrdinaryMiniGame', 'jsapipay', 'wxminigame', 'wxminigame_ios', 'bilibili_minigame_pay', 'aliminigame_ios', 'aliminigame']

/**
 * 渠道名称覆盖映射表
 * key: dimensionCode（payChlCode）
 * value: 前端展示的自定义 tab 名称
 * 后续有新的覆盖需求，在此处追加即可
 */
export const CHANNEL_NAME_OVERRIDE_MAP: Record<string, string> = {
  jsapipay: 'ios卡片支付',
}

/** 将后端返回的渠道名称转换为前端展示名称，有覆盖配置则优先使用覆盖值 */
export function resolveChannelName(code: string, fallbackName: string): string {
  return CHANNEL_NAME_OVERRIDE_MAP[code] ?? fallbackName
}

export const columns: TableColumnsType = [
  {
    title: '产品ID',
    key: 'dbtId',
    dataIndex: 'dbtId',
    width: 52,
  },
  {
    title: '产品名称',
    key: 'appName',
    dataIndex: 'appName',
  },
]
